export class SetCatalogNav {
    public static readonly type = '[Catalog] SetCatalogNav';
}
